import React from 'react';

import { switchToCurrentNetwork } from '../utils/BlockchainAPI';
import { handleError } from '../utils/ErrorHandler';


const ChangeNetworkLink = () => {

  const performSwitch = () => {
    try {
      switchToCurrentNetwork();
    } catch (err) {
      handleError(err);
    }
  }

  return (
    <span className="textLink" onClick={performSwitch}>tapping here</span>
  );
}

export default ChangeNetworkLink;